'use es6';

import { makeRequestStatusSelector } from 'pricing-pages-unified-ui/selectors/RequestStatusSelectors';
import { getRequiredOnboardingSkuId } from 'pricing-pages-lib/utils/requiredOnboardingUtils';
import { createSelectorFromUtil } from 'pricing-pages-lib/utils/selectorUtils';
import { FetchRequiredOnboardingRequestTypes } from '../actions/RequiredOnboardingActions';
import { transformState } from './SelectorUtils';
export const fetchRequiredOnboardingStatus = makeRequestStatusSelector(FetchRequiredOnboardingRequestTypes.REQUEST);
export const requiredOnboardingSkuIdSelector = createSelectorFromUtil(getRequiredOnboardingSkuId, transformState);